import React from "react";
import { QuestionsExport } from "../../modules/QuestionsExport";
import { UploadFiles } from "../../modules/UploadFiles";
import { UploadType } from "../../static/enums/UploadType";

export default function () {
	return (
		<>
			<UploadFiles title={"XLS-файл с вопросами и ZIP-файл с картинками"} type={UploadType.questions} multiple />
			<QuestionsExport />
		</>
	);
}
